"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.countryList = exports.DataByCountry = void 0;
var _CountryCodePhone = require("../constants/CountryCodePhone");
const DataByCountry = (country, action = 'currency') => {
  let selectCountry = _CountryCodePhone.phonecode.find(item => item.code.toUpperCase() === country.toUpperCase());
  if (country.length === 2) selectCountry = _CountryCodePhone.phonecode.find(item => item.code.toUpperCase() === country.toUpperCase());
  if (typeof selectCountry !== 'undefined') {
    if (action === 'currency') return selectCountry.currency;
  }
  return selectCountry;
};
exports.DataByCountry = DataByCountry;
const countryList = exports.countryList = [{
  label: '🌍 Everywhere',
  shortLabel: '🌍 All',
  onlyFlag: '🌍',
  full: 'Everywhere',
  short: 'ALL',
  value: 'all',
  location: {
    lat: 44.82,
    lng: 4.31
  }
}, {
  label: '🇦🇹 Austria',
  shortLabel: '🇦🇹 AT',
  onlyFlag: '🇦🇹',
  full: 'Austria',
  short: 'AUT',
  value: 'AT',
  location: {
    lat: 48.20817,
    lng: 16.37382
  }
}, {
  label: '🇩🇰 Denmark',
  shortLabel: '🇩🇰 DK',
  onlyFlag: '🇩🇰',
  full: 'Denmark',
  short: 'DNK',
  value: 'DK',
  location: {
    lat: 55.67610,
    lng: 12.56834
  }
}, {
  label: '🇩🇪 Germany',
  shortLabel: '🇩🇪 DE',
  onlyFlag: '🇩🇪',
  full: 'Germany',
  short: 'DEU',
  value: 'DE',
  location: {
    lat: 52.52001,
    lng: 13.40495
  }
}, {
  label: '🇮🇹 Italy',
  shortLabel: '🇮🇹 IT',
  onlyFlag: '🇮🇹',
  full: 'Italy',
  short: 'ITA',
  value: 'IT',
  location: {
    lat: 43.4617,
    lng: 11.1515
  }
}, {
  label: '🇳🇱 Netherlands',
  shortLabel: '🇳🇱 NL',
  onlyFlag: '🇳🇱',
  full: 'Netherlands',
  short: 'NLD',
  value: 'NL',
  location: {
    lat: 52.36670,
    lng: 4.89454
  }
}, {
  label: '🇵🇹 Portugal',
  shortLabel: '🇵🇹 PT',
  onlyFlag: '🇵🇹',
  full: 'Portugal',
  short: 'PRT',
  value: 'PT',
  location: {
    lat: 38.72225,
    lng: -9.13934
  }
}, {
  label: '🇨🇭 Switzerland',
  shortLabel: '🇨🇭 CH',
  onlyFlag: '🇨🇭',
  full: 'Switzerland',
  short: 'SWI',
  value: 'CH',
  location: {
    lat: 47.37689,
    lng: 8.54169
  }
}];